/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.searchPostsV2'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      25,
    ),
  ),
  query: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  sort: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['recent', 'top'] }>(),
  ),
  authors: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  mentions: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  domains: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  urls: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'uri' })),
  ),
  embeddedAtUris: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' })),
  ),
  hashtags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
  ),
  excludeAuthors: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  excludeMentions: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  excludeDomains: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  excludeUrls: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'uri' })),
  ),
  excludeEmbeddedAtUris: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' })),
  ),
  excludeHashtags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
  ),
  since: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  until: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  allTime: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  languages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' })),
  ),
  excludeLanguages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' })),
  ),
  hasMedia: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  hasVideo: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  replyParentUri: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
  threadRootUri: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
  excludeReplies: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  repliesOnly: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  following: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  queryLanguage: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['ja', 'zh', 'ko', 'th', 'ar'] }>(),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  hitsTotal: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  posts: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any),
  ),
  detectedQueryLanguages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{ knownValues: ['ja', 'zh', 'ko', 'th', 'ar'] }>(),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Find posts matching a search query or filters, returning search hits for matching post records. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['BadQueryString'])

export { main }

export const $lxm = $nsid
